<template>
  <div class="container">
    <sys-dialog
      v-show="dialogVisible"
      :bgi="dialogBgi"
      :show-close="true"
      :error-msg="errorMsg"
      @close="closeDialog"
    />
    <sys-loading :loading="loading" />
    <div :class="isMobile ? 'root' : 'content'">
      <div class="main">
        <img class="logo" src="../assets/logo.png" />
        <img class="title" src="../assets/sport/title.png" />
        <div class="form">
          <div class="tags">
            <span
              :class="isRegisterAction ? 'tag register active' : 'tag register'"
              @click="isRegisterAction = true"
            ></span>
            <span
              :class="!isRegisterAction ? 'tag active' : 'tag'"
              @click="isRegisterAction = false"
            ></span>
          </div>
          <div class="inputs">
            <div class="form-input">
              <img src="../assets/sport/icon-username.png" />
              <input
                v-model="form.username"
                placeholder="Tên đăng nhập"
                maxlength="20"
                autocomplete="off"
              />
            </div>
            <div class="form-input" v-show="isRegisterAction">
              <img src="../assets/sport/icon-phone.png" />
              <input
                v-model="form.phone"
                placeholder="Số điện thoại"
                maxlength="10"
                oninput="value=value.replace(/^\D/, '')"
              />
            </div>
            <div
              class="form-input"
              :style="!isRegisterAction ? { marginBottom: 0 } : ''"
            >
              <img src="../assets/sport/icon-password.png" />
              <input
                v-model="form.password"
                type="password"
                autocomplete="new-password"
                placeholder="Mật khẩu"
              />
            </div>
            <div
              class="form-input"
              v-show="isRegisterAction"
              style="margin-bottom: 0;"
            >
              <img src="../assets/sport/icon-email.png" />
              <input
                v-model="form.email"
                autocomplete="off"
                placeholder="Email"
              />
            </div>
            <a
              v-if="!isRegisterAction"
              class="error"
              href="https://www.888b.com"
              >Quên Mật Khẩu?</a
            >

            <v-captcha
              ref="vcaptcha1"
              :dialogVisible="dialogVisible"
              :showCheck="showCheck"
              @cb="handleConfirm"
              :vstyle="{ top: '31px' }"
              :nativeButton="
                isMobile
                  ? {
                      width: '178px',
                      height: '49px'
                    }
                  : {
                      width: '288px',
                      height: '66px'
                    }
              "
            >
              <div
                v-show="isRegisterAction"
                class="submitBtn reg"
                :style="
                  `background-image: url(${require('../assets/sport/btn-register.png')});background-size: 100% 100%;`
                "
                @click="submitAction(1)"
              ></div>
            </v-captcha>
            <div
              v-show="!isRegisterAction"
              class="submitBtn login"
              :style="
                `background-image: url(${require('../assets/sport/btn-login.png')});background-size: 100% 100%;`
              "
              @click="submitAction(2)"
            ></div>
          </div>
        </div>
        <div class="btm">
          <a href="https://m.me/888BVN" target="_blank"
            ><img src="../assets/sport/icon-fb.png"
          /></a>
          <a href="https://t.me/nhacai888b" target="_blank"
            ><img src="../assets/sport/icon-tg.png"
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import {FORM_VALID_MESSAGE, DOMAIN_INVITE_CODE, DOMAIN_AGENT_LINE} from "../utils/constant";
import {userRegister, userLogin, createCustomer, sendEndPoint} from "../utils/request";
import { encodePlatformUrl, validForm, isMobile } from "../utils/tools";
import { captcha } from "@/mixins/captcha";

export default {
  name: "Sport",
  mixins: [captcha],
  data() {
    return {
      isMobile: isMobile(),
      swiperMobileVisible: false,
      isRegisterAction: true,
      dialogVisible: false,
      loading: false,
      dialogBgi: require("../assets/sport/bgi-dialog.png"),
      form: {
        by: 1,
        username: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      errorMsg: {
        title: "",
        content: ""
      },
      swiperOptions: {
        speed: 1000,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        }
      }
    };
  },
  mounted() {
    this.swiperMobileVisible = isMobile() && window.innerWidth > 360;
    window.onresize = () => {
      this.isMobile = isMobile();
      this.swiperMobileVisible = this.isMobile && window.innerWidth > 360;
    };
  },
  methods: {
    submitAction(type) {
      let errorMsg = validForm(type, this.form);
      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }
      this.loading = true;
      // 登陆
      if (type == 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.username,
          phone: temp.phone,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode = DOMAIN_INVITE_CODE[location.host] || "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.form.userName = this.form.username;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        this.loading = false;
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
::-webkit-input-placeholder {
  color: #ffffff;
}

.content,
.root {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.content {
  background-image: url("../assets/sport/bgi-pc.jpg");
  background-size: 100% 100%;

  .main {
    width: 45%;
    height: 100%;
    padding: 30px 0;
    margin-right: 100px;
    float: right;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;

    img.logo {
      width: 25%;
    }

    img.title {
      width: 75%;
      margin: 30px 0;
    }

    .form {
      width: 577px;
      height: 425px;
      background-image: url("../assets/sport/bgi-form.png");
      background-size: 100% 100%;

      .tags {
        width: 100%;
        height: 18%;
        position: relative;
        top: -6.8%;
        display: flex;
        align-items: center;
        justify-content: center;

        .tag {
          width: 38%;
          height: 75%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-image: url("../assets/sport/tag-login.png");
          background-size: 100% 100%;
          cursor: pointer;
          position: relative;

          &.register {
            background-image: url("../assets/sport/tag-regist.png");
          }

          &.active {
            height: 90%;
            width: 45%;
          }
        }
      }

      .inputs {
        height: 86%;
        position: relative;
      }

      .form-input {
        width: 70%;
        height: 13%;
        position: relative;
        margin: 0 auto 20px;

        img {
          width: 30px;
          height: 30px;
          position: absolute;
          top: calc(50% - 15px);
          left: 20px;
        }

        input {
          width: 100%;
          height: 100%;
          background: transparent url("../assets/sport/bgi-input.png") no-repeat;
          background-size: 100% 100%;
          border: none;
          outline: none;
          text-indent: 70px;
          font-size: 24px;
          color: #ffffff;
        }
      }

      a.error {
        display: block;
        margin: 20px;
        color: #ffffff;
        font-size: 20px;
        text-decoration: none;
        text-align: center;
      }
      .submitBtn {
        width: 50%;
        height: 18%;
        cursor: pointer;
        position: absolute;
        bottom: 0;
        left: 25%;

        &.login {
          height: 25%;
          bottom: -10px;
        }
      }
    }

    .btm {
      width: 150px;
      margin: 20px auto 0;
      display: flex;
      justify-content: space-between;
      img {
        width: 50px;
      }
      img {
        width: 50px;
        cursor: pointer;
      }
    }
  }
}

/deep/ .close-img {
  width: 40px;
  height: 40px;
  opacity: 0;
  top: 40px !important;
  right: 50px !important;
}

@media only screen and (max-width: 767px) {
  /deep/ .moda {
    padding: 20vw !important;
  }

  /deep/ .close-img {
    width: 7vw !important;
    height: 7vw !important;
    opacity: 0;
    top: 8vw !important;
    right: 6vw !important;
  }
}

.root {
  background-image: url("../assets/sport/bgi-h5.jpg");
  background-size: 100% 100%;

  .main {
    display: flex;
    flex-flow: column;
    align-items: center;
    padding-top: 5vw;

    .logo {
      width: 30%;
    }
    .title {
      width: 100%;
    }

    .form {
      width: 95%;
      height: 46vh;
      margin-top: 10vw;
      background-image: url("../assets/sport/bgi-form.png");
      background-size: 100% 100%;

      .tags {
        width: 100%;
        height: 14%;
        position: relative;
        top: -4%;
        display: flex;
        align-items: center;
        justify-content: center;

        .tag {
          width: 38%;
          height: 80%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-image: url("../assets/sport/tag-login.png");
          background-size: 100% 100%;
          cursor: pointer;
          position: relative;

          &.register {
            background-image: url("../assets/sport/tag-regist.png");
          }

          &.active {
            height: 110%;
            width: 45%;
          }
        }
      }

      .inputs {
        height: 86%;
        position: relative;
      }

      .form-input {
        width: 70%;
        height: 13%;
        position: relative;
        margin: 0 auto 20px;

        img {
          width: 5vw;
          height: 6vw;
          position: absolute;
          top: 2vw;
          left: 3vw;
        }

        input {
          width: 100%;
          height: 100%;
          background: transparent url("../assets/sport/bgi-input.png") no-repeat;
          background-size: 100% 100%;
          border: none;
          outline: none;
          text-indent: 3em;
          font-size: 1em;
          color: #ffffff;
        }
      }

      a.error {
        display: block;
        margin: 20px;
        color: #ffffff;
        font-size: 20px;
        text-decoration: none;
        text-align: center;
      }
      .submitBtn {
        width: 50%;
        height: 18%;
        cursor: pointer;
        position: absolute;
        bottom: -6%;
        left: 25%;

        &.login {
          height: 25%;
          bottom: -10%;
        }

        &:active {
          bottom: -4px;
        }
      }
    }

    .btm {
      width: 30%;
      margin: 4vw auto 0;
      display: flex;
      justify-content: space-between;
      img {
        width: 50px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sport.vue